// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink_AppLink__Ed-Ws","secondary":"AppLink_secondary__2B6K2","AppLink_active":"AppLink_AppLink_active__16DrQ"};